import { AccessorsMutatorsDecorator, Model } from "../../helpers";

export class SystemConfiguration extends Model {

}

AccessorsMutatorsDecorator('option', 'value', 'value_with_vat')(SystemConfiguration);


// WEBPACK FOOTER //
// ./src/pms-api/models/system-configuration.model.js